/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
import React, { Component, Fragment } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';

import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';

import { connect } from 'react-redux';
import { setLoading } from './redux/other/other.actions';
import './App.css';

import { getUser, setUser, clearToken, getToken } from './strapi/strapi.utils.js';
import { withSnackbar } from 'notistack';

import Notifier from './components/Notifier/Notifier';

import {
  loadProduseStart,
  loadMaterialeStart,
  loadOptionaleStart,
  loadCuloriStart,
  loadPreturiTabelareStart,
  loadInformariStart,
  loadIndicatoriStart,
  loadFirmaStart,
  loadFirmeComisionarStart,
  loadCursStart
} from './redux/lookup/lookup.actions';
import { setCurrentUserSuccess, setDeliveryAddressesStart } from './redux/user/user.actions';
import { selectCurrentUser } from './redux/user/user.selectors';

import { strapi } from 'strapi/strapi.config';

import FadeIn from 'react-fade-in';
import Lottie from 'react-lottie';
import 'bootstrap/dist/css/bootstrap.css';

import * as legoData from './views/Loading/legoloader.json';
import * as doneData from './views/Loading/doneloading.json';
import { t } from './i18n';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: legoData.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const defaultOptions2 = {
  loop: false,
  autoplay: true,
  animationData: doneData.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const browserHistory = createBrowserHistory();

validate.validators = {
  ...validate.validators,
  ...validators
};

const getHttpStatus = (error) =>
  error?.status ||
  error?.statusCode ||
  error?.response?.status ||
  error?.response?.statusCode;

const AUTH_SESSION_VERSION_KEY = 'auth_session_version';
const AUTH_SESSION_VERSION =
  process.env.REACT_APP_AUTH_SESSION_VERSION || '2026-11-05-force-relogin';

class App extends Component {
  state = {
    loadingResurse: false,
    mesajIncarcare: ''
  };

  setMesajIncarcare = (mesaj) => {
    this.setState({ mesajIncarcare: mesaj });
  };

  async loadToateResursele(idFirma, currentUserData) {
    const {
      loadProduseStart,
      loadMaterialeStart,
      loadOptionaleStart,
      loadCuloriStart,
      loadPreturiTabelareStart,
      loadInformariStart,
      loadIndicatoriStart,
      loadFirmaStart,
      loadFirmeComisionarStart,
      loadCursStart,
      setDeliveryAddressesStart
    } = this.props;

    try {
      // Încărcăm datele firmei
      await loadFirmaStart(idFirma);
      
      // Încărcăm restul resurselor în paralel pentru performanță mai bună
      await Promise.all([
        loadProduseStart(),
        loadMaterialeStart(),
        loadOptionaleStart(),
        loadCuloriStart(),
        loadInformariStart(),
        loadPreturiTabelareStart(),
        loadCursStart(),
        setDeliveryAddressesStart(idFirma)
      ]);
      if (currentUserData?.idFirma?.cfg1 === 'DA') {
        await loadFirmeComisionarStart(idFirma);
      }

      // Încărcăm indicatorii la final
      if (this.verificareLocalStorage() >= 11) {
        await loadIndicatoriStart();
      } else {
        setTimeout(() => {
          loadIndicatoriStart();
        }, 2000);
      }

      return true;
    } catch (error) {
      console.error('Eroare la încărcarea resurselor:', error);
      return false;
    }
  }

  async componentDidMount() {
    const wasForcedLogout = await this.enforceAuthSessionVersion();
    if (wasForcedLogout) {
      return;
    }

    // Verificăm dacă suntem pe pagina de login
    const isLoginPage = window.location.pathname === '/sign-in';
    if (isLoginPage) {
      return;
    }

    // Verificăm autentificarea
    const token = getToken();
    const currentUser = getUser();

    if (!token || !currentUser) {
      window.location.href = '/sign-in';
      return;
    }

    const userUpdateSuccess = await this.setCurrentUserUpdate();
    if (!userUpdateSuccess) {
      return;
    }

    const updatedUser = getUser();
    if (updatedUser && (await this.verificareUtilizator())) {
      await this.loadToateResursele(updatedUser?.idFirma?.id || 0, updatedUser);
    }
  }

  async enforceAuthSessionVersion() {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }

    const savedVersion = localStorage.getItem(AUTH_SESSION_VERSION_KEY);
    if (savedVersion === AUTH_SESSION_VERSION) {
      return false;
    }

    const hadActiveSession = Boolean(getToken() || getUser());
    await clearToken();
    localStorage.setItem(AUTH_SESSION_VERSION_KEY, AUTH_SESSION_VERSION);
    this.props.setCurrentUserSuccess(null);

    if (hadActiveSession) {
      window.location.replace('/sign-in');
      return true;
    }

    return false;
  }

  async verificareUtilizator() {
    console.log('verificareUtilizator: Începe verificarea...');
    try {
      const token = getToken();
      if (!token) {
        console.log('verificareUtilizator: Nu există token');
        return false;
      }

      console.log('verificareUtilizator: Verificare conexiune API');
      const response = await strapi.getEntries('indicators', { indicator: 'InregistrariNoi' });
      console.log('verificareUtilizator: Răspuns API:', response);
      
      if (!response || response.length === 0) {
        console.log('verificareUtilizator: Nu s-au primit date de la API');
        return false;
      }
      
      console.log('verificareUtilizator: Verificare reușită');
      return true;
    } catch (error) {
      console.log('verificareUtilizator: EROARE:', error.message);
      const status = getHttpStatus(error);
      if (status === 401 || status === 403) {
        await clearToken();
        this.props.setCurrentUserSuccess(null);
        window.location.reload();
        return false;
      }
      // Nu delogăm utilizatorul la erori tranzitorii de rețea/server.
      return true;
    }
  }

  verificareLocalStorage() {
    return Object.keys(localStorage).length;
  }

  async setCurrentUserUpdate() {
    console.log('setCurrentUserUpdate: Începe actualizarea...');
    const currentUtilizator = getUser();
    console.log('setCurrentUserUpdate: Date utilizator din localStorage:', currentUtilizator);
    
    // Verificăm dacă nu suntem deja pe pagina de login
    const isLoginPage = window.location.pathname === '/sign-in';
    console.log('setCurrentUserUpdate: Este pagina de login?', isLoginPage);
    
    if (!currentUtilizator || !currentUtilizator.idFirma) {
      console.log('setCurrentUserUpdate: Nu există utilizator sau idFirma în localStorage');
      await clearToken();
      this.props.setCurrentUserSuccess(null);
      if (!isLoginPage) {
        console.log('setCurrentUserUpdate: Redirecționare către login');
        window.location.href = '/sign-in';
      }
      return false;
    }

    try {
      console.log('setCurrentUserUpdate: Apel API pentru firma:', currentUtilizator.idFirma.id);
      const res = await strapi.getEntries('firmas', { id: currentUtilizator?.idFirma?.id || 0 });
      console.log('setCurrentUserUpdate: Răspuns API:', res);
      
      if (!res || res.length === 0) {
        throw new Error('Nu s-au găsit date pentru firmă');
      }

      const updatedUser = { ...currentUtilizator, idFirma: res[0], comandas: [] };
      setUser(updatedUser);
      this.props.setCurrentUserSuccess(updatedUser);
      console.log('setCurrentUserUpdate: Actualizare reușită');
      return true;
    } catch (e) {
      console.log('setCurrentUserUpdate: EROARE:', e.message);
      const status = getHttpStatus(e);
      if (status === 401 || status === 403) {
        await clearToken();
        this.props.setCurrentUserSuccess(null);
        if (!isLoginPage) {
          window.location.href = '/sign-in';
        }
        return false;
      }
      // Continuăm cu datele locale dacă API-ul are probleme temporare.
      this.props.setCurrentUserSuccess(currentUtilizator);
      return true;
    }
  }

  render() {
    const { loading } = this.props;

    if (loading) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ background: '#CFD8DC', height: '100vh' }}
        >
          <FadeIn>
            <div className="d-flex justify-content-center align-items-center">
              <h3>{t('app.loadingData')}</h3>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <Lottie options={defaultOptions} height={300} width={300} />
            </div>
          </FadeIn>
          <Notifier />
        </div>
      );
    }

    return (
      <ThemeProvider theme={theme}>
        <Router history={browserHistory}>
          <Fragment>
            <Routes />
            <Notifier />
          </Fragment>
        </Router>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.other.loading,
  done: state.other.done,
  currentUser: selectCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUserSuccess: (user) => dispatch(setCurrentUserSuccess(user)),
  loadProduseStart: () => dispatch(loadProduseStart()),
  loadMaterialeStart: () => dispatch(loadMaterialeStart()),
  loadOptionaleStart: () => dispatch(loadOptionaleStart()),
  loadCuloriStart: () => dispatch(loadCuloriStart()),
  loadPreturiTabelareStart: () => dispatch(loadPreturiTabelareStart()),
  loadInformariStart: () => dispatch(loadInformariStart()),
  loadIndicatoriStart: () => dispatch(loadIndicatoriStart()),
  loadFirmaStart: (id) => dispatch(loadFirmaStart(id)),
  loadFirmeComisionarStart: (id) => dispatch(loadFirmeComisionarStart(id)),
  loadCursStart: () => dispatch(loadCursStart()),
  setLoading: (boll) => dispatch(setLoading(boll)),
  setDeliveryAddressesStart: (idFirma) => dispatch(setDeliveryAddressesStart(idFirma))
});

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(App));
